module.exports = __webpack_public_path__ + "img/zen.d1de8ac4.svg";